import * as React from 'react';

export const SolvdWarning = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="33" height="33" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.7337 4.02845C11.7277 2.26135 14.2719 2.26135 15.2659 4.02845L22.5203 16.9251C23.4952 18.6583 22.2427 20.7998 20.2542 20.7998H5.74539C3.75684 20.7998 2.50438 18.6583 3.47929 16.9252L10.7337 4.02845ZM14.2997 16.9C14.2997 17.6179 13.7176 18.2 12.9997 18.2C12.2817 18.2 11.6997 17.6179 11.6997 16.9C11.6997 16.182 12.2817 15.6 12.9997 15.6C13.7176 15.6 14.2997 16.182 14.2997 16.9ZM12.9997 6.49998C12.2817 6.49998 11.6997 7.08201 11.6997 7.79998V11.7C11.6997 12.4179 12.2817 13 12.9997 13C13.7176 13 14.2997 12.4179 14.2997 11.7V7.79998C14.2997 7.08201 13.7176 6.49998 12.9997 6.49998Z"
			fill="#F08F08"
		/>
	</svg>
);
